module.exports = __webpack_public_path__ + "static/children-374d6a9658aafca351aab063566b2639.jpg";